export default __webpack_public_path__ + "static/media/simple-octobass.23377aed.svg";